var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardiology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31104 13.7496C4.73926 15.9668 7.07254 18.0208 8.96175 19.4687C10.2937 20.4896 10.9597 21 12 21C13.0403 21 13.7063 20.4896 15.0383 19.4687C17.3479 17.6986 20.3213 15.0226 21.4932 12.25H17.8107L14.0303 16.0303C13.7374 16.3232 13.2626 16.3232 12.9697 16.0303L7.00002 10.0607L3.31104 13.7496Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56196 12.3774C2.2072 11.5764 2 10.7662 2 9.96653C2 4.08262 7.50016 1.88586 12 6.43111C16.4998 1.88586 22 4.08262 22 9.9665C22 10.2268 21.978 10.4882 21.9362 10.75H17.5C17.3011 10.75 17.1103 10.829 16.9697 10.9697L13.5 14.4393L7.53033 8.46967C7.23744 8.17678 6.76256 8.17678 6.46967 8.46967L2.56196 12.3774Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.675f5f256bb3704e25d9a8201a8525b5.svg";
export { ForwardRef as ReactComponent };